import Vue from 'vue';
import Component from 'vue-class-component';
import * as i18next from 'i18next';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

export interface DialogMessageModel {
    contentClass: string;
    title: string;
    text: string;
    size: string;
    persistent?: boolean;
    btnOkLabel?: string;
    btnCancelLabel?: string;
    btnOkHandler?: Function;
    btnCancelHandler?: Function;
    btnOkColorClass?: string;
    btnCancelColorClass?: string;
    btnCloseHandler?: Function;
}

@WithRender
@Component
export class DialogMessageComponent extends Vue {
    contentClass: string = '';
    title: string = '';
    text: string = '';
    size: string = 'md';
    persistent: boolean = false;
    btnOkLabel: string = '';
    btnCancelLabel?: string = '';
    btnOkHandler?: Function;
    btnCancelHandler?: Function;
    btnCloseHandler?: Function;
    btnOkColorClass?: string = '';
    btnCancelColorClass?: string = '';

    get contentClasses(): string {
        let c = 'v-dialog_' + this.size;

        if (!this.title) {
            c += ' v-dialog--no-title';
        }

        if (this.contentClass) {
            c += ' ' + this.contentClass;
        }

        return c;
    }

    onOk() {
        (<any>this).$refs.dialog.isActive = false;

        if (this.btnOkHandler) {
            this.btnOkHandler();
        }
    }
    onCancel() {
        (<any>this).$refs.dialog.isActive = false;

        if (this.btnCancelHandler) {
            this.btnCancelHandler();
        }
    }

    onClose() {
        (<any>this).$refs.dialog.isActive = false;

        if (this.btnCloseHandler) {
            this.btnCloseHandler();
        }
    }

    show(model: DialogMessageModel) {
        this.contentClass = model.contentClass;
        this.title = model.title;
        this.text = model.text;
        this.size = model.size ? model.size : 'md';
        this.persistent = model.persistent ? model.persistent : false;
        this.btnOkLabel = model.btnOkLabel ? model.btnOkLabel : i18next.t('button_ok');
        this.btnCancelLabel = model.btnCancelLabel;
        this.btnOkHandler = model.btnOkHandler;
        this.btnCancelHandler = model.btnCancelHandler;
        this.btnOkColorClass = model.btnOkColorClass;
        this.btnCancelColorClass = model.btnCancelColorClass;
        this.btnCloseHandler = model.btnCloseHandler;
        (<any>this).$refs.dialog.isActive = true;
    }
}
